import React from 'react';
import { twMerge } from 'tailwind-merge';

import {
  Icon,
  type Ryecon,
  RyeconColorBigquery,
  RyeconColorDatabricks,
  RyeconColorRedshift,
  RyeconColorSnowflake,
  RyeconHelp,
  SizeType,
} from '@dbt-labs/sourdough';

import {
  getWarehouseType,
  warehouseNameMap,
  WarehouseType,
  WarehouseTypeOrUnknown,
} from '../typings';

export const warehouseIconMap: Record<WarehouseTypeOrUnknown, Ryecon> = {
  snowflake: RyeconColorSnowflake,
  databricks: RyeconColorDatabricks,
  bigquery: RyeconColorBigquery,
  redshift: RyeconColorRedshift,
  unknown: RyeconHelp,
};

export type WarehouseIconProps = {
  warehouse?: WarehouseType | 'unknown';
  size?: SizeType;
  testId?: string;
} & React.ComponentPropsWithoutRef<'span'>;

export const WarehouseTypeIcon: React.FC<WarehouseIconProps> = ({
  warehouse,
  size,
  className: classNameOverrides,
  testId,
}) => {
  const iconName = getWarehouseType(warehouse, 'unknown');
  const className = twMerge('text-center', classNameOverrides);
  const title = warehouseNameMap[iconName];

  return (
    <Icon
      className={className}
      ryecon={warehouseIconMap[iconName]}
      alt={title}
      size={size}
      testId={testId}
    />
  );
};
